import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import NextLink from 'next/link';
import React, { ComponentProps } from 'react';

type Props = ComponentProps<typeof NextLink>;

const StyledLink = styled(NextLink, {
  shouldForwardProp: isPropValid,
})(() =>
  css({
    cursor: 'pointer',
    textDecoration: 'none',
  })
);

export const Link: React.FC<Props> = props => {
  return <StyledLink {...props} />;
};
